import React, { useRef, useEffect } from "react";
import ApplicationFallback from "../applicationFallback/ApplicationFallback";
import { useNavigate } from "react-router-dom";

type Props = {
    to: string
}

// This is not a real redirect
const Redirect: React.FC<Props> = ({ to }) => {

    const navigate = useNavigate()

    const canGo = useRef(true);
    useEffect(() => {
        if(canGo.current === true) {
            canGo.current = false;

            navigate(to);
        }
    }, []);

    return (
        <ApplicationFallback />
    )
}

export default Redirect;